export default "__VITE_ASSET__OW2BZnjJ__"